class SlideshowsComponent extends HTMLElement {
    constructor() {
      super();
      this.slider = this.querySelector('[id^="Slider-"]');
  
      if (!this.slider) return;
      this.initPages();
      const resizeObserver = new ResizeObserver(entries => this.initPages());
      resizeObserver.observe(this.slider);
    }
    
    
    initPages() {
      const sliderActive = this.slider.id;
      const slick = $("#" + sliderActive);
      slick.not('.slick-initialized').slick({
        prevArrow: '<span class="slick-btn slick-prev slick-arrow" ><svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="16.9999" cy="16.9998" r="17" transform="rotate(180 16.9999 16.9998)" fill="white"/><circle cx="16.9999" cy="16.9998" r="16.5" transform="rotate(180 16.9999 16.9998)" stroke="black" stroke-opacity="0.7"/><path d="M17.9999 11.9998L13.9999 16.4998L17.9999 20.9998" stroke="#49BFCD" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></svg></span>', 
        nextArrow: '<span class="slick-btn slick-next slick-arrow" ><svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="17" cy="17" r="17" fill="white"/><circle cx="17" cy="17" r="16.5" stroke="black" stroke-opacity="0.7"/><path d="M16 22L20 17.5L16 13" stroke="#49BFCD" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></svg></span>'
      });
  
      slick.on("lazyLoaded", function (event, slick, image, imageSource) {
        lazyCounter++;
        if (lazyCounter === lazyImages.length) {
          lazyImages.addClass("show");
        }
      });
  
  
    }
  }
  
  customElements.define('slideshows-component', SlideshowsComponent);

  

$(function() {

  $('.featured-prouduct__add-to-cart').on('click', function(e) {
    var form = $('#addToCart');
    e.preventDefault();
    console.log(form);

    $.ajax({
        type: 'POST',                             
        url: '/cart/add.js',
        dataType: 'json',                               
        data: form.serialize(),
        success: function(data) {
            form.find('input[name="checkout"]').trigger('click');
        }
    });
});


function featureProductSlider(){

if ( $('.product__slider-main').length ) {
  var $slider = $('.product__slider-main')
      .on('init', function(slick) {
          $('.product__slider-main').fadeIn(1000);
      }).not('.slick-initialized').slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          arrows: false,
          autoplay: false,
          lazyLoad: 'ondemand',
          autoplaySpeed: 3000,
          asNavFor: '.product__slider-thumb',
          prevArrow:'<button class="slick-prev-btn"><svg xmlns="http://www.w3.org/2000/svg" width="12" height="13" viewBox="0 0 12 13" fill="none"><path d="M7.5 3.5L4.5 6.5L7.5 9.5" stroke="currentColor" stroke-width="2.25" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
          nextArrow:'<button class="slick-next-btn"><svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4.5 3.5L7.5 6.5L4.5 9.5" stroke="currentColor" stroke-width="2.25" stroke-linecap="round" stroke-linejoin="round"/></svg></button>'      
      });

var $slider2 = $('.product__slider-thumb')
      .on('init', function(slick) {
          $('.product__slider-thumb').fadeIn(1000);
      }).not('.slick-initialized').slick({
          slidesToShow: 6,
          slidesToScroll: 1,
          lazyLoad: 'ondemand',
          asNavFor: '.product__slider-main',
          dots: false,
          infinite: true,
          focusOnSelect: true,
          arrows: false
      });


$('.product__slider-thumb .slick-slide').removeClass('slick-active');
//set active class to first thumbnail slides
$('.product__slider-thumb .slick-slide').eq(0).addClass('slick-active');
// On before slide change match active thumbnail to current slide
$('.product__slider-main').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
var mySlideNumber = nextSlide;
$('.product__slider-thumb .slick-slide').removeClass('slick-active');
$('.product__slider-thumb .slick-slide').eq(mySlideNumber).addClass('slick-active');
});


}

}

featureProductSlider();


document.addEventListener('shopify:block:select', () => featureProductSlider());
document.addEventListener('shopify:block:deselect', () => featureProductSlider());
document.addEventListener('shopify:section:select', () => featureProductSlider());
document.addEventListener('shopify:section:deselect', () => featureProductSlider());




$('.accordion__head').on('click', function() {
    if($(this).hasClass('active')) {
    $(this).siblings('.accordion__content').slideUp();
    $(this).removeClass('active');
    }
    else {
    $('.accordion__content').slideUp();
    $('.accordion__head').removeClass('active');
    $(this).siblings('.accordion__content').slideToggle();
    $(this).toggleClass('active');
    }
}); 




$('a[href*="#"]')
.not('[href="#"]')
.not('[href="#0"]')
.click(function(event) {
  if (
    location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') 
    && 
    location.hostname == this.hostname
  ) {
    var target = $(this.hash);
    target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
    if (target.length) {
      event.preventDefault();
      $('html, body').animate({
        scrollTop: target.offset().top
      }, 1000, function() {
        var $target = $(target);
        $target.focus();
        if ($target.is(":focus")) { 
          return false;
        } else {
          $target.attr('tabindex','-1');
          $target.focus(); 
        };
      });
    }
  }
});



});